import React, { FC } from 'react';
import cn from 'classnames';
import styles from './CarouselIndicators.module.scss';

export interface CarouselIndicatorsProps {
  length: number;
  onScroll: (index: number) => void;
  current: number;
}

const CarouselIndicators: FC<CarouselIndicatorsProps> = ({ length, onScroll, current }) => {
  return (
    <ol className={styles.carouselIndicators}>
      {[...Array(length)].map((el, index) => (
        <span
          key={`indicator_${index}`}
          onClick={() => onScroll(index)}
          className={cn({ [styles.active]: current === index })}
        />
      ))}
    </ol>
  );
};

export default CarouselIndicators;
